import { RemainingCharsValidatedTextField } from '@bingads-webui-campaign-react/remaining-chars-hint';

export const ServerValidatedRemainingCharsValidatedTextField = RemainingCharsValidatedTextField;
